export const environment = {
  production: false,
  //gatewayBaseUrl: 'https://localhost:7198/',
  gatewayBaseUrl: 'https://gateway.tutorontip.com/',
  imageBaseUrl: 'https://user-course.tutorontip.com'
};

